import { connect } from 'react-redux';
import TermsView from './TermsView';
import {
  selectTermsRawText,
  selectIsAcceptingTerms,
  selectIsFetchingTerms,
  selectAreTermsAccepted,
  selectWhitelabelLogo,
  selectAreDataAggregationTermsAccepted,
} from './TermsSelector';
import { acceptTerms, fetchTerms } from './TermsActions';

const mapStateToProps = (state, { forDataAggregation }) => {
  return {
    termsRawText: selectTermsRawText(state),
    isAcceptingTerms: selectIsAcceptingTerms(state),
    isFetchingTerms: selectIsFetchingTerms(state),
    areTermsAccepted: forDataAggregation
      ? selectAreDataAggregationTermsAccepted(state)
      : selectAreTermsAccepted(state),
    whitelabelLogo: selectWhitelabelLogo(state),
  };
};

const mapDispatchToProps = (dispatch, { clientId, forDataAggregation }) => ({
  fetchTerms: () => dispatch(fetchTerms(clientId, forDataAggregation)),
  onAcceptTerms: () => {
    dispatch(acceptTerms(clientId, forDataAggregation));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(TermsView);
